export default function preloaderGame14 (scene) {

    scene.load.image(`tilesgame14`, `/tiles/game14.png`);

	scene.load.audio("song", ["/audio/songs/13-reason.mp3"]);

	// scene.load.spritesheet(`jiu1-game14`, 
	// 	`/img/game1/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua1-game14`, 
	// 	`/img/game1/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon1-game14`, 
	// 	`/img/game1/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong1-game14`, 
	// 	`/img/game1/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon1-game14`, 
	// 	`/img/game1/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami1-game14`, 
	// 	`/img/game1/dami.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon1-game14`, 
	// 	`/img/game1/gahyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	

	// scene.load.spritesheet(`jiu2-game14`, 
	// 	`/img/game2/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua2-game14`, 
	// 	`/img/game2/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon2-game14`, 
	// 	`/img/game2/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong2-game14`, 
	// 	`/img/game2/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon2-game14`, 
	// 	`/img/game2/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami2-game14`, 
	// 	`/img/game2/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon2-game14`, 
	// 	`/img/game2/gahyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );


	// scene.load.spritesheet(`jiu3-game14`, 
	// 	`/img/game3/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua3-game14`, 
	// 	`/img/game3/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon3-game14`, 
	// 	`/img/game3/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong3-game14`, 
	// 	`/img/game3/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon3-game14`, 
	// 	`/img/game3/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami3-game14`, 
	// 	`/img/game3/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon3-game14`, 
	// 	`/img/game3/gahyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );


	// scene.load.spritesheet(`jiu4-game14`, 
	// 	`/img/game4/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua4-game14`, 
	// 	`/img/game4/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon4-game14`, 
	// 	`/img/game4/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong4-game14`, 
	// 	`/img/game4/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon4-game14`, 
	// 	`/img/game4/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami4-game14`, 
	// 	`/img/game4/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon4-game14`,
	// 	`/img/game4/gahyeon.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );




	// scene.load.spritesheet(`jiu5-game14`, 
	// 	`/img/game5/jiu.png`,
	// 	{ frameWidth: 26, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua5-game14`, 
	// 	`/img/game5/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon5-game14`, 
	// 	`/img/game5/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong5-game14`, 
	// 	`/img/game5/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon5-game14`, 
	// 	`/img/game5/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami5-game14`, 
	// 	`/img/game5/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon5-game14`,
	// 	`/img/game5/gahyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );


	// scene.load.spritesheet(`jiu6-game14`, 
	// 	`/img/game6/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua6-game14`, 
	// 	`/img/game6/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon6-game14`, 
	// 	`/img/game6/siyeon.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong6-game14`, 
	// 	`/img/game6/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon6-game14`, 
	// 	`/img/game6/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami6-game14`, 
	// 	`/img/game6/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon6-game14`,
	// 	`/img/game6/gahyeon.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );



	// scene.load.spritesheet(`jiu7-game14`, 
	// 	`/img/game7/jiu.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua7-game14`, 
	// 	`/img/game7/sua.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`siyeon7-game14`, 
	// 	`/img/game7/siyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`handong7-game14`, 
	// 	`/img/game7/handong.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`yoohyeon7-game14`, 
	// 	`/img/game7/yoohyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	// scene.load.spritesheet(`dami-game7`, 
	// 	`/img/game7/dami.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );
	
	// scene.load.spritesheet(`gahyeon-game7`,
	// 	`/img/game7/gahyeon.png`,
	// 	{ frameWidth: 25, frameHeight: 37}
	// );

	scene.load.tilemapTiledJSON(`game14`, `/tiles/game14.tmj`);

}